<!--<ng-container *ngIf="data[fieldName]">{{moment(data[fieldName]).format('MM/DD/YYYY')}}</ng-container>-->
<!--<ng-container *ngIf="data[fieldName]">{{moment(data[fieldName]).format('MM/DD/YYYY')}}</ng-container>-->
<ng-container *ngIf="data[fieldName]">{{data[fieldName] | dateCustomFormat: 'MM/DD/YYYY'}}</ng-container>
